/* global USE_SENTRY, LD_CLIENT_ID */
import React from 'react'
import { render } from 'react-dom'
import * as Sentry from '@sentry/react'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'

import makeStore, { history } from './store'
import './initIntegrations'

import App from './App'
import { defaultAnonymousContext } from './helpers/IdHelpers'

import './ant.less'
import './index.css'


import { unregister } from './registerServiceWorker'
unregister()

let store

if (USE_SENTRY === 'true') {
  const sentryReduxEnhancer = Sentry.createReduxEnhancer()
  const storeConfig = {
    sentry: sentryReduxEnhancer,
  }
  store = makeStore(storeConfig)
} else {
  store = makeStore()
}

;(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LD_CLIENT_ID,
    context: defaultAnonymousContext,
    timeout: 3,
  })

  render(
    <LDProvider>
      <App store={store} history={history} />
    </LDProvider>,
    document.getElementById('root'),
  )
})()

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    render(
          <NextApp store={store} history={history} />,
          document.getElementById('root'),
    )
  })
}
